/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class Price
{
    private _locale: string = 'pl-PL';
    private _currency: string = 'PLN';

    constructor(locale: string = 'pl-PL', currency: string = 'PLN')
    {
        this._locale = locale;
        this._currency = currency;
    }

    public getFormated(price: number): string {
        return price.toLocaleString(this._locale, {
            style: 'currency',
            currency: this._currency,
        })
    }
}